export const CPC_BAR_CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    grid: { show: false },
    legend: {
        show: true,
        horizontalAlign: 'center',
        position: 'top'
    },
    xaxis: {
        title: {
            text: 'Months',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: { show: true },
        categories: [
            '0', '1', '2', '3',
            '4', '5', '6', '7',
            '8', '9', '10'
        ]
    },
    yaxis: {
        title: {
            text: 'Cost Per 30 Second of Session Visit',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            formatter: (value) => value,
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        }
    },
    dataLabels: { enabled: false },
    colors: ['#AD509E', '#E9BEE3'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
            columnWidth: '50px'
        }
    },
    tooltip: {
        y: {
            formatter: function (value) {
                return '$'+value;
            }
        }
    }
};

export const CPC_H = {
    title: { text: null },
    subtitle: { text: null },
    chart: {
        backgroundColor: 'transparent',
        type: 'column'
    },
    colors: ['#AD509E'],
    mapNavigation: {
        enabled: false,
        enableButtons: false
    },
    navigation: { buttonOptions: { enabled: false } },
    credits: { enabled: false },
    tooltip: {
        enabled: true,
        formatter: function () {
            return `<b>${this.point.category}</b><br/>Cost: $${this.point.y.toFixed(2)}`;
        }
    },
    legend: { enabled: false },
    dataLabels: { enabled: false },
    plotOptions: {
        column: {
            stacking: 'normal',
            borderRadius: 3,
            maxPointWidth: 50
        }
    },
    xAxis: {
        categories: [], // Categories will be dynamically updated
        title: { text: 'Months' },
        lineColor: 'transparent'
    },
    yAxis: {
        min: 0,
        title: { text: 'Cost Per 30 Second of Session Visit' },
        stackLabels: { enabled: false },
        lineColor: 'transparent',
        gridLineWidth: 0
    }
};

